'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// MapModal

function MapModal(_ref) {
  var isMapOpen = _ref.isMapOpen,
      closeMap = _ref.closeMap,
      mapTitle = _ref.mapTitle,
      children = _ref.children;

  return _react2.default.createElement(
    _Modal2.default,
    {
      isOpen: isMapOpen,
      style: {
        /* TODO: move the style to css file */
        overlay: {
          zIndex: 10000
        },
        content: {
          overflow: 'visible'
        }
      }
    },
    _react2.default.createElement('div', { id: 'map-show-backdrop' }),
    _react2.default.createElement(
      'div',
      { className: 'hotel-name-map' },
      mapTitle
    ),
    _react2.default.createElement(
      'div',
      { id: 'map-show-container' },
      _react2.default.createElement(
        'div',
        { className: 'map-show-panel' },
        children
      ),
      _react2.default.createElement('span', { className: 'map-show-close', onClick: closeMap })
    )
  );
}

MapModal.propTypes = {
  isMapOpen: _react.PropTypes.bool.isRequired,
  closeMap: _react.PropTypes.func.isRequired,
  children: _react.PropTypes.element.isRequired,
  mapTitle: _react.PropTypes.string.isRequired
};

exports.default = MapModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MapModal.js
// module id = 577
// module chunks = 0